import React, { PureComponent, Fragment } from 'react'
import { Col, Label, FormFeedback, FormGroup } from "reactstrap"
import PropTypes from 'prop-types'
import DayPickerInput from 'react-day-picker/DayPickerInput';
import 'react-day-picker/lib/style.css';
import { FaRegCalendarAlt } from 'react-icons/fa';
import dateFnsFormat from 'date-fns/format';
import addDays from 'date-fns/addDays';
import { formatoData, formatLaravelTimestamp, formatLaravelDate, parseDate, formatDate, pt_br } from '../funcoes'
/**********************************************************************************************************************************************/
//Componente responsavel por configurar um date do react-day-picker de acordo com a necessidade de gerar formulario dinamicos para supervisor//
/********************************************************************************************************************************************/
// POR PADRÃO TODA DATA É FORMATADA PARA O FORMATO BRASILEIRO

class DateForm extends PureComponent {
    constructor(props) {
        super(props)

        // Ensure we have valid date objects by properly parsing the values
        const dataInicialValue = this.props.dataInicial.value || this.props.dataInicial.valorPadrao;
        const dataFinalValue = this.props.dataFinal ? (this.props.dataFinal.value || this.props.dataFinal.valorPadrao) : undefined;
        
        // Convert string dates to Date objects properly
        let fromDate = null;
        let toDate = null;
        
        try {
            fromDate = dataInicialValue ? parseDate(dataInicialValue, formatLaravelTimestamp) : undefined;
            toDate = dataFinalValue ? parseDate(dataFinalValue, formatLaravelTimestamp) : undefined;
        } catch (e) {
            console.error('Error parsing date:', e);
        }
        
        this.state = {
            from: fromDate,
            to: toDate,
            manipuladoPeloUsuario: false,
            manipuladoPeloUsuarioTo: false,
            telaAgenda: props.style?.telaAgenda ?? false
        }

        if (this.props.dataFinal && !this.props.dataFinal.style) {
            this.props.dataFinal.style = style
        }

    }

    isValid = (final) => {
        if (final)
            return ((this.state.manipuladoPeloUsuarioTo || this.props.submit) && this.props.invalido && !this.state.to)
        else
            return ((this.state.manipuladoPeloUsuario || this.props.submit) && this.props.invalido && !this.state.from)
    }

    changeClass = (final = false) => {
        if (this.isValid(final)) {
            return {
                width: "100%",
                border: "1px solid red",
                padding: ".375rem .75rem",
                boxSizing: "border-box",

                borderRadius: '0.7rem',
                height: 'calc(1.5em + .75rem)',
            }
        } else {
            return {
                width: "100%",
                border: "1px solid #ced4da",
                padding: ".375rem .75rem",
                boxSizing: "border-box",

                borderRadius: '0.7rem',
                height: 'calc(1.5em + .75rem)',
            }
        }
    }

    onChange = (tipo, valor) => {
        // Get current values with proper fallback
        const values = this.props.value ? this.props.value : this.state;
        let { from, to } = values;
        
        // Ensure we have valid date objects
        if (from && typeof from === 'string') {
            try {
                from = parseDate(from, formatLaravelTimestamp);
            } catch (e) {
                console.error('Error parsing from date:', e);
                from = null;
            }
        }
        
        if (to && typeof to === 'string') {
            try {
                to = parseDate(to, formatLaravelTimestamp);
            } catch (e) {
                console.error('Error parsing to date:', e);
                to = null;
            }
        }
        
        // Now handle the changes safely
        if (tipo === "data_inicial") {
            if (this.props.dataFinal) {
                this.setState({ from: valor, to: this.props.dataFinal.intervalo ? undefined : to });
                const toFormated = this.props.dataFinal.intervalo ? undefined : formatDate(to, formatLaravelDate);
                this.props.onChange(this.props.name, { from: formatDate(valor, formatLaravelDate), to: toFormated });
            } else {
                this.setState({ from: valor });
                this.props.onChange(this.props.name, formatDate(valor, formatLaravelDate));
            }
        } else {
            this.setState({ to: valor });
            this.props.onChange(this.props.name, { from: formatDate(from, formatLaravelDate), to: formatDate(valor, formatLaravelDate) });
        }
    }

    render() {
        // Get values with proper fallback order: props.value > state
        const values = this.props.value ? this.props.value : this.state;
        
        // Make sure we're working with proper Date objects
        let from = values.from;
        let to = values.to;
        
        // If dates are strings, parse them
        if (from && typeof from === 'string') {
            try {
                from = parseDate(from, formatLaravelTimestamp);
            } catch (e) {
                console.error('Error parsing from date:', e);
                from = null;
            }
        }
        
        if (to && typeof to === 'string') {
            try {
                to = parseDate(to, formatLaravelTimestamp);
            } catch (e) {
                console.error('Error parsing to date:', e);
                to = null;
            }
        }
        
        // Only create modifiers if we have valid Date objects
        const modifiers = from && to ? { start: from, end: to } : from ? { start: from } : {};
        const diasFuturos = this.props.dataInicial.diasFuturos ? undefined : new Date();
        
        // Build dayPickerProps safely
        let dayPickerProps;
        if (this.props.dataFinal) {
            dayPickerProps = { 
                selectedDays: from ? (to ? [from, { from, to }] : [from]) : [],
                disabledDays: to ? { after: to } : {}, 
                modifiers, 
                onDayClick: () => !to && this.to && this.to.getInput().focus() 
            };
        } else {
            dayPickerProps = { disabledDays: { after: diasFuturos } };
        }
        return (
            <Fragment>
                <Col {...this.props.dataInicial.style.col} className="form-col">
                    <FormGroup className={(this.props.hidden ? "hidden" : "")}>
                        <Label className={this.props.dataInicial.style.labelClass + " label"}>
                            {this.props.dataInicial.iconLabel && <FaRegCalendarAlt size="18px" style={{ marginRight: "10px" }} />}
                            {this.props.dataInicial.label + ":"}
                        </Label>
                        {/* <FormGroup className = "form-group-feedback-input"> */}
                        <DayPickerInput placeholder={this.props.dataInicial.placeholder}
                            name={this.props.dataInicial.name ? this.props.dataInicial.name : `${dateFnsFormat(new Date(), formatoData)}`}
                            value={from}
                            format={formatoData}
                            formatDate={formatDate}
                            readOnly={this.props.dataInicial.readOnly}
                            parseDate={parseDate}
                            onDayChange={this.onChange.bind(this, "data_inicial")}
                            dayPickerProps={{ locale: 'pt-br', ...pt_br, ...dayPickerProps }}
                            inputProps={{
                                onBlur: () => this.setState({ manipuladoPeloUsuario: false }),
                                style: this.changeClass(),
                                disabled: this.props.dataInicial.readOnly,
                                // Ensure input is formatted correctly
                                value: from ? formatDate(from, formatoData) : ''
                            }}
                        />
                        <FormFeedback style={{ display: (this.isValid()) ? "block" : "none" }}>
                            {"Selecione uma opção valida !"}
                        </FormFeedback>
                        {/* </FormGroup> */}
                    </FormGroup>
                </Col>

                {(this.props.dataFinal) &&
                    <Col  {...this.props.dataFinal.style.col} className="form-col">
                        <FormGroup className={(this.props.hidden ? "hidden" : "")}>
                            <Label className={this.props.dataFinal.style.labelClass + " label"}>
                                {this.props.dataFinal.label + ":"}
                            </Label>
                            {/* <FormGroup className = "form-group-feedback-input"> */}
                            <DayPickerInput ref={el => (this.to = el)}
                                value={to}
                                placeholder={this.props.dataFinal.placeholder}
                                months={pt_br.months}
                                formatDate={formatDate}
                                format={formatoData}
                                parseDate={parseDate}
                                onDayChange={this.onChange.bind(this, "data_final")}
                                inputProps={{
                                    onBlur: () => this.setState({ manipuladoPeloUsuarioTo: true }),
                                    style: this.changeClass(true),
                                    disabled: this.props.dataFinal.readOnly,
                                    // Ensure input is formatted correctly
                                    value: to ? formatDate(to, formatoData) : ''
                                }}
                                dayPickerProps={{
                                    locale: 'pt-br',
                                    selectedDays: [from, { from, to }],
                                    disabledDays: {
                                        before: from,
                                        after: this.props.dataFinal.intervalo ? addDays(from, this.props.dataFinal.intervalo) : undefined
                                    },
                                    modifiers,
                                    month: from,
                                    fromMonth: from,
                                    ...pt_br
                                }}
                            />
                            <FormFeedback style={{ display: (this.isValid(true)) ? "block" : "none" }}>
                                Selecione uma opção valida !
                                </FormFeedback>
                            {/* </FormGroup> */}
                        </FormGroup>
                    </Col>
                }
            </Fragment>
        )
    }
}

export default DateForm

const colShape = {
    xs: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    sm: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    md: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    lg: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    xl: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

const styleShape = {
    labelClass: PropTypes.string,
    elementoClass: PropTypes.string,
    col: PropTypes.shape(colShape)

}

const dataShape = {
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    intervalo: PropTypes.number,
    style: PropTypes.shape(styleShape)
}

const style = {
    labelClass: "label-conteudoInferior",
    elementoClass: "",
    col: {
        xs: 12,
        sm: 12,
        md: 12,
        lg: 12,
        xl: 12
    }
}

DateForm.propTypes = {
    name: PropTypes.string.isRequired,
    innerRef: PropTypes.object,
    onChange: PropTypes.func.isRequired,
    dataInicial: PropTypes.shape(dataShape).isRequired,
    dataFinal: PropTypes.shape(dataShape)
}

DateForm.defaultProps = {
    placeholder: "",
    dataInicial: {
        style: {}
    },
};

// configurações do React day Picker
